import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import { DividaVencidaRow } from 'src/modules/motor-credito/serasa/serasa.pj.types'

export type DividaVencidaProps = {
    dividaVencida: DividaVencidaRow
}

export default function DividaVencida({ dividaVencida }: DividaVencidaProps) {
    return (
        <>
            <Divider textAlign="center">Dívida Vencida</Divider>
            {dividaVencida && (
                <Grid
                    container
                    spacing={1}
                    sx={{
                        paddingTop: 2,
                        paddingBottom: 2,
                        paddingLeft: 5,
                        paddingRight: 5
                    }}
                >
                    <GridItem label="Total Ocorrências" value={dividaVencida.total_ocorrencias.toFixed(0)} xs={6} />
                    <GridItem label="Total Valores" value={dividaVencida.total_valores.toFixed(2)} xs={6} />

                    {dividaVencida.ocorrencias?.map((ocorrencia, index) => (
                        <Grid key={index} container spacing={1}>
                            <GridItem label="Data" value={formatDate(ocorrencia.data, 'dd/MM/yyyy')} xs={6} />
                            <GridItem label="Modalidade" value={ocorrencia.modalidade} xs={6} />
                            <GridItem label="Valor" value={ocorrencia.valor.toFixed(2)} xs={6} />
                            <GridItem label="Título" value={ocorrencia.titulo} xs={6} />
                            <GridItem label="Inst. Cobradora" value={ocorrencia.inst_cobradora} xs={6} />
                            <GridItem label="Local" value={ocorrencia.local} xs={6} />
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    )
}
